import { useState } from "react";
import { _AbstractAccount, _single } from "../../../../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../../../../core/services/dataBean/useDataBean"
import { BasicTable, MASK_NUMBER } from "../../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../../theme/Component/Modal";
import { AccountEditor } from "../../../../../../../editor/AccountEditor";
import { BasicButton } from "../../../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../../theme/Component/ListMenu";
import useModal, { MODAL_md } from "../../../../../../../theme/Component/hooks/useModal";
import { ImportXLSX } from "../../../../../../../theme/Component/ImportXLSX";

interface Props {
    label?: string;
    onChange: Function;
}

export const EmployeeList = ({ label, onChange }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AbstractAccount)
    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [account, setAccount] = useState<any>({});

    const head = [
        { title: 'ID', property: 'IDAccount', visible: true, mask: MASK_NUMBER },
        { title: 'Identificación', property: 'Nit', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const addPeople = () => {
        if (account.IDAccount) {
            instance.createEmployeeListRow(account.IDAccount).then(
                (resp) => {
                    setLista((prev) => [...prev, { DataBeanProperties: resp, DataBeanName: "com.quickdataerp.bean.employees.EmployeeList" }])
                    setAccount({});
                }
            ).catch(err => { toast.error(err) })
        } else {
            toast.error("Usuario no Valido")
        }
    }

    const returnData = () => {
        const filteredIds = lista.map(item => item.DataBeanProperties.IDAccount);
        if (filteredIds.length > 0) {
            onChange?.(filteredIds);
            setModal({ ...modal, view: false })
        } else {
            toast.error("Debe Seleccionar al menos un Usuario")
        }
    }

    const deleteItem = (idAccount: number) => {
        setLista((prev: any[]) =>
            prev.filter(
                item =>
                    item.DataBeanProperties.IDAccount !== idAccount
            )
        );
    };


    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar', icono: 'ri-eraser-line', visible: true, evento: () => { deleteItem(bean.IDAccount) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const modalUpdateExcel = useModal("Actualizar Mediante Excel", MODAL_md);
    const [listImport, setListImport] = useState([]);

    const importMenu = async () => {
        if (!listImport || listImport.length <= 1) {
            toast.warning("No hay datos válidos para importar");
            return;
        }

        // Obtener NIT existentes
        const existe = lista.map(e => String(e?.DataBeanProperties?.Nit ?? "").trim());

        const errores: number[] = [];
        let exitos = 0;

        // Bucle secuencial (espera cada iteración)
        for (let index = 1; index < listImport.length; index++) {
            const row = listImport[index];
            const nit = String(row?.[0] ?? "").trim();

            if (!nit) {
                errores.push(index);
                continue;
            }

            if (existe.includes(nit)) {
                toast.info(`El usuario con la CC:${nit} ya se encuentra en la lista`);
                continue;
            }

            await instance.getAccountByNit(Number(nit)).then(
                (resp) => {
                    if (resp.length > 0 && resp[0].DataBeanProperties.IDAccount) {
                        instance.createEmployeeListRow(resp[0].DataBeanProperties.IDAccount).then(
                            (resp2) => {
                                setLista(prev => [
                                    ...prev,
                                    { DataBeanProperties: resp2, DataBeanName: "com.quickdataerp.bean.employees.EmployeeList" },
                                ]);
                                exitos++;
                            }
                        ).catch(err => {
                            console.error(`Error creando fila ${index}:`, err);
                            errores.push(index);
                        });
                    } else {
                        toast.warning(`No se encontró cuenta con NIT ${nit}`);
                        errores.push(index);
                    }
                }
            ).catch(err => {
                toast.warning(`Error al buscar la cuenta con NIT ${nit}`);
                errores.push(index);
            });
        }

        if (exitos > 0) {
            toast.success(`Importación completada: ${exitos} empleados agregados`);
        }

        if (errores.length > 0) {
            toast.error(`Errores en filas: ${errores.join(", ")}`);
        }

        modalUpdateExcel.close();
    };



    return (
        <>

            <label>{label ? label : 'Lista de Empleados'}</label>
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={`${lista.map(item => item.DataBeanProperties.IDAccount).join(", ")}`}
                onClick={() => { setModal({ ...modal, "view": true }) }}
            />

            <Modal modal={modal} updateModal={setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-8">
                        <AccountEditor idAccount={account.IDAccount} label="Empleado" onChange={(e) => { setAccount(e) }} />
                    </div>
                    <div className="col-md-2">
                        <BasicButton useMargin eventClick={() => { addPeople() }} icon="ri-add-line" children={`Agregar`} />
                    </div>
                    <div className="col-md-2 ">
                        <BasicButton useMargin eventClick={() => { modalUpdateExcel.open() }} icon="ri-file-upload-line" children={`Importar`} />

                        <Modal modal={modalUpdateExcel.modal} updateModal={modalUpdateExcel.setModal} eventModal={importMenu} onSubmitLabel="Importar">
                            <div className="row">
                                <div className="col">
                                    <ImportXLSX lodaData={setListImport} />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
                    </div>

                </div>
            </Modal>


        </>
    )
}